<template>
  <el-dialog width="35%"
             v-dialog-drag
             title="邀请"
             :before-close="handleClickCancel"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :visible.sync="wxInviteVisible">
    <el-form size="small"
             ref="inviteForm"
             label-position="left"
             label-width="85px"
             :model="inviteForm"
             :rules="inviteFormRules" v-loading="loading">
       <div class="hintTitle">点击该链接后，您的公司将激活，您将成为超级管理员</div>
      <el-form-item label="邀请链接：" prop="">
        <el-input  ref="copyInput" placeholder="" readonly v-model="inviteForm.url"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small"  type="primary" @click="handleClickCopy">复制</el-button>
      <el-button size="small"  @click="handleClickCancel">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { StoreWxappAdd, StoreWxappEdit, StoreWxappDetails } from '@/api'
import { uploadImg, getOSSData } from '@/utils/uploadOss'

export default {
  name: 'wxInvite',
  props: {
    wxInviteVisible: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: Number,
      default: 0,
    },
    companyUrl: {
      type: String,
      default: '',
    }

  },
  data () {
    return {
      inviteForm: {
        url:''
      },
      inviteFormRules: { },
      loading: false
    }
  },
  created () {
  },
  mounted () {
    if(this.companyUrl){
      this.inviteForm.url = this.companyUrl
    }
  },
  methods: {
    //取消事件
    handleClickCancel () {
      //重置表格
      this.$refs.inviteForm.resetFields()
      //关闭对话框
      this.$emit('update:wxInviteVisible', false)
    },
    // 复制
    handleClickCopy(){
      this.$refs.copyInput.select()
      document.execCommand("copy");
      this.$message.success('复制成功')

    },
  },

}
</script>
<style lang="scss" scoped>
.hintTitle {
  font-size: 14px;
  line-height: 36px;
  color: #000;
  margin-top: 5px;
}

.upload_img_wrap {
  width: 148px;
  height: 148px;
}

.upload_img_wrap img {
  width: 146px;
  height: 146px;
}
</style>
